import rsapi from '../rsapi';
import $ from "jquery";
import { gzip } from "pako";

// let config = {
//     headers: {
//         'Authorization': $.session.get("Token"),
//         'X-TenantID': $.session.get("tenantid"),
//         'Accept': 'application/json',
//         "Content-Type": "application/json",
//         "Content-Encoding": "gzip",
//     },
//     responseType: 'arraybuffer'
// }

// let configwithoutgzip = {

//     headers: {
//         //'Authorization': $.session.get("Token"),
//         'Authorization': sessionStorage.getItem("Token"),
//         'X-TenantID': $.session.get("tenantid"),
//         'Accept': 'application/json',
//         "Content-Type": "application/json",
//         "Content-Encoding": "gzip",
//     }
// }

export const config = () => ({
    headers: {
        'Authorization': $.session.get("Token"),
        'X-TenantID': $.session.get("tenantid"),
        'Accept': 'application/json',
        'Content-Type': 'application/json',
        'Content-Encoding': 'gzip',
    },
    responseType: 'arraybuffer'
});

export const configwithoutgzip = () => ({
    headers: {
        'Authorization': sessionStorage.getItem("Token"),
        'X-TenantID': $.session.get("tenantid"),
        'Accept': 'application/json',
        "Content-Type": "application/json",
        "Content-Encoding": "gzip",
    }
});

export const getNestedFieldData = (nestedColumnArray, data) =>
    nestedColumnArray.reduce((xs, x) => (xs && xs[x]) ? xs[x] : null, data);

export function create_UUID() {
    let dt = new Date().getTime();
    let uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        let r = (dt + Math.random() * 16) % 16 | 0;
        dt = Math.floor(dt / 16);
        return (c === 'x' ? r : (r + 0x3 | 0x8)).toString(16);
    });
    return uuid;
}


export function extractColumnHeader(fieldList, visibility) {
    let columnList = [];
    console.log(fieldList);
    if (fieldList !== undefined && visibility === true //&& fieldList.length !== undefined
        && fieldList.length !== 0)// && fieldList.valueOf.length !==0)
    {
        //---removing fisrt feild -primary key
        let keyFilteredList = fieldList.filter(function (value, index, arr) {
            return index > 0;
        });

        //---removing 'signImageUrl', 'userImageUrl
        let fieldFilteredList = keyFilteredList.filter(function (value, index, arr) {
            return value.datatype !== 'signImageUrl' && value.datatype !== 'userImageUrl'
                && value.datatype !== 'site' && value.datatype !== 'detailedData';
        });


        //---removing last 3 fields (status, createdby, createddate)
        columnList = fieldFilteredList.filter(function (value, index, arr) {
            // console.log("value, arr", value, arr)     ;
            return index < arr.length - 3;
        });

    }
    return columnList;
}

export function getCurrentDateTime() {
    var tempDate = new Date();
    var date = tempDate.getFullYear() + '-' + (tempDate.getMonth() + 1) + '-' + tempDate.getDate() + ' ' + tempDate.getHours() + ':' + tempDate.getMinutes() + ':' + tempDate.getSeconds();
    //const currDate = "Current Date= "+date;
    return date;
}


export function getLocaleStringDate(date, time) {
    //default locale - 'en-US' MM/dd/yyyy  
    return date.toLocaleDateString().concat(" " + time);
}

export function getTimeZoneFormattedDate(date, timeZone) {
    var options = {  //weekday: 'long', 
        year: 'numeric', month: 'numeric', day: 'numeric',
        hour: 'numeric', minute: 'numeric', second: 'numeric',
        timeZone: timeZone,
        timeZoneName: 'short'
    };
    //console.log("date:", date, timeZone);
    const formattedDate = new Intl.DateTimeFormat('ko', options).format(new Date(date));
    //DateTimeFormatter.ofPattern("dd/MM/yyyy HH:mm:ss Z").format(date);
    // console.log(new Date(date).toLocaleDateString('de', options));
    return formattedDate;
}
export function isDate(data) {
    console.log("date:", new Date(data) instanceof Date && !isNaN(new Date(data).valueOf()) ? "true" : "false");
    return new Date(data) instanceof Date && !isNaN(new Date(data).valueOf());
}

export function getTabs(tabObject) {
    return tabObject.map((tabObject, index) => ({
        title: tabObject.name,
        getContent: () => tabObject.content,
        /* Optional parameters */
        key: index,
        tabClassName: 'tab',
        panelClassName: 'panel',
    }));
}

export async function getParserMethod() {
    console.log(configwithoutgzip);
    return rsapi.post("/getParserMethod", await gzip(JSON.stringify({})), configwithoutgzip());
}

export function getInstCategory() {
    return rsapi.post("/getInstCategory");
}

export async function getDelimiterList(inputData) {
    console.log(configwithoutgzip);
    return rsapi.post("/getDelimiters", await gzip(JSON.stringify({ inputData })), configwithoutgzip());
}

export function getParserData(inputData) {
    return rsapi.post("/getParserData", inputData, config());
}

export function getversionParserData(inputData) {
    return rsapi.post("/getversionParserData", inputData, config());
}
export function uploadimportFile(inputData) {
    return rsapi.post("/uploadimportFile", inputData, config());
}
export function getmethodversion(inputData) {
    return rsapi.post("/getmethodversion", inputData, config());
}
export function getMethodDelimiter() {
    return rsapi.post("/getMethodDelimiter", config());
}

export function getSubParserMethod() {
    return rsapi.post("/getSubParserMethod", config());
}

export function getParserFieldTechniqueListByMethodKey(inputData) {
    return rsapi.post("/getParserFieldTechniqueListByMethodKey", inputData, config());
}

export async function getFileData(inputData) {
    return rsapi.post("/getFileData", await gzip(JSON.stringify({ inputData })), config())
}

export async function getSampleTextSplitByMethod(inputData) {
    return rsapi.post("/getSampleTextSplitByMethod", await gzip(JSON.stringify({ inputData })), config())
}

export async function getSampleLineSplitByMethod(inputData) {
    return rsapi.post("/getSampleLineSplitByMethod", await gzip(JSON.stringify({ inputData })), config())
}

export async function getSampleExtractByMethod(inputData) {
    return rsapi.post("/getSampleExtractByMethod", await gzip(JSON.stringify({ inputData })), config())
}

export function getControlTypeList(inputData) {
    return rsapi.post("/getControlType", inputData, config());
}

export function getActiveMethodListBySite(inputData) {
    return rsapi.post("/getMethod", inputData, config());
}
